import { If } from 'common/src/components';
import classnames from 'classnames';
import React, { Fragment } from 'react';
import { Iconfont } from '@umu/umu-design';

interface IConfigInfo {
    isHtmlTpl?: boolean;
}
interface IProps {
    columns: string[];
    className?: string;
    configInfo?: Record<string, IConfigInfo>;
    list: Record<string, any>[];
}

const CircleLabelList = (props: IProps) => {
    const { columns = [], list = [], className = '' } = props;
    const renderItem = (keys: string) => {
        const { isHtmlTpl = false } = props.configInfo?.[keys] || {};
        return list.map((item, index) => {
            const keyIndex = `static-item-${index}-${keys}`;
            switch (keys) {
                case 'color':
                    return (
                        <span key={keyIndex} className="static-circle" style={{ backgroundColor: item.color }}></span>
                    );
                case 'iconfont':
                    return (
                        <Iconfont
                            key={keyIndex}
                            type={item[keys]}
                            className={`static-iconfont static-iconfont-${item[keys]}`}
                        />
                    );
                default:
                    return (
                        <Fragment key={keyIndex}>
                            <If condition={isHtmlTpl}>
                                <span
                                    className={classnames({
                                        'static-label': true,
                                        [`static-label-${keys}`]: true,
                                        'static-label-indent': item.indent,
                                    })}
                                    dangerouslySetInnerHTML={{ __html: item[keys] }}
                                />
                            </If>
                            <If condition={!isHtmlTpl}>
                                <span
                                    className={classnames({
                                        'static-label': true,
                                        [`static-label-${keys}`]: true,
                                        'static-label-indent': item.indent,
                                    })}
                                >
                                    {item[keys]}
                                </span>
                            </If>
                        </Fragment>
                    );
            }
        });
    };

    const renderList = () => {
        return columns.map((item, index) => {
            return (
                <div className="static-item" key={`static-range-${index}`}>
                    {renderItem(item)}
                </div>
            );
        });
    };
    return <div className={`static-range-time ${className}`}>{renderList()}</div>;
};
const renderCircleLabelList = (props: IProps) => {
    return <CircleLabelList {...props}></CircleLabelList>;
};

export { IProps, CircleLabelList, renderCircleLabelList };
